import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/** How the Containers tab draws each box's events. */
export type ContainersView = "list" | "table";

interface TrackingViewState {
	/**
	 * Persisted: it is how someone likes to read tracking, not a state of one
	 * shipment, so it holds across shipments and reloads.
	 */
	containersView: ContainersView;
}

const initialState: TrackingViewState = {
	containersView: "list",
};

const trackingViewSlice = createSlice({
	name: "trackingView",
	initialState,
	reducers: {
		setContainersView: (state, action: PayloadAction<ContainersView>) => {
			state.containersView = action.payload;
		},
	},
});

export const { setContainersView } = trackingViewSlice.actions;
export default trackingViewSlice.reducer;
